<template>
  <div @mouseup="getImageHeight">
    <figure class="resizer" :class="[position]" ref="figure" :style="{ 'max-height': maxHeight }">
      <img ref="img" :src="imageUrl" alt="Picture" width="100%" height="auto" />
    </figure>
  </div>
</template>
<script>
import validator from "validator";
import eventBus from "@/boot/eventBus";
export default {
  props: {
    image: String,
    callback: {
      type: Function,
      required: true
    },
    position: {
      type: String,
      default: "left"
    },
    maxHeight: {
      type: String,
      default: "500px"
    }
  },
  computed: {
    imageUrl() {
      if (this.urlValidator(this.image) || this.image.startsWith("data:")) {
        return this.image;
      }
      return "data:image/png;base64," + this.image;
    }
  },
  data() {
    return {};
  },
  watch: {
    image() {
      this.$refs.figure.style.height = "";
      this.$refs.figure.style.width = "";
    }
  },
  methods: {
    urlValidator(url) {
      if (!url) {
        return false;
      }
      return validator.isURL(url, { require_protocol: false, require_tld: false });
    },
    resizeImage() {
      // Create canvas to get new image url resized
      const img = this.$refs.img;
      if (!img) {
        return;
      }
      const figure = this.$refs.figure;

      let width = figure.style.width.replace("px", "");
      let height = figure.style.height.replace("px", "");

      if (!width && !height) {
        //didnt change the image
        return;
      }

      const image = new Image();
      image.setAttribute("crossorigin", "anonymous");
      const vm = this;

      image.addEventListener("load", function () {
        var canvas = document.createElement("canvas");

        if (width === "") {
          width = img.clientWidth;
        }
        if (height === "") {
          height = img.clientHeight;
        }
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, width, height);

        var dataurl = canvas.toDataURL("image/png");

        dataurl = dataurl.replace(`data:image/png;base64,`, "");

        // Go to screen
        vm.callback(dataurl);
      });
      image.src = img.src;
    },
    checkHeight() {
      const img = this.$refs.img;
      if (img) {
        var height = img.clientHeight;
        this.$refs.figure.style.height = height + "px";
      }
    },

    getImageHeight() {
      this.checkHeight();
      this.resizeImage();
    },
    handleMouseOut(e) {
      if (e.buttons !== 1) {
        this.resizeImage();
      }
    }
  },
  created() {
    // Read mouse up on parent component
    // The mouseup click could be in the parent and not fire the resize image
    eventBus.$on("RESIZE_MOUSE_UP", (e) => {
      this.handleMouseOut(e);
    });
  }
};
</script>
<style scoped>
.resizer.right {
  direction: rtl;
}
.resizer.left {
  direction: ltr;
}
.resizer {
  resize: both;
  overflow: auto;
  border: 2px solid var(--organization-secondary-color);
  overflow-y: hidden;
  /* max-width: 430px; */
  /* max-height: 500px; */
  /* width: 100%; */
  /* height: 100%; */
  max-height: 100%;
  padding: 0;
  margin: 0;
}
.resizer::-webkit-resizer {
  background-color: var(--organization-secondary-color);
}
.img {
  max-width: 100%;
  max-height: 100%;
  display: block;
}
.title {
  color: #354052;
  font-size: 18px;
}
</style>
